import React, { Component } from "react";

import "./LoadingPage.css";

export default class LoadingPage extends Component {

  render() {
    // TODO: replace text with a throbber or something
    return (
      <div className="loading-page">
        <div className="throbber">
          <div className="bounce1"></div>
          <div className="bounce2"></div>
          <div className="bounce3"></div>
        </div>
        <div className="loading-page__text">Loading...</div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/LoadingPage.js